export default "__VITE_ASSET__C2X8svhE__"